import { type FC } from "react";
import { type ButtonProps } from "@snapchat/snap-design-system";
import { AccessContainer } from "../../common/containers";
import { DisabledButtonToolipFix, ActionDisabledTooltip } from "../../common/components/ActionDisabledTooltip";
import { AuthOperationTypes } from "../../gql-generated";
import { UnauthorizedMessage } from "./UnauthorizedMessage";

export interface EnableAppButtonProps {
    organizationId: string;
    hasApps: boolean;
}

export const EnableAppButton: FC<EnableAppButtonProps & ButtonProps> = ({
    organizationId,
    hasApps,
    onClick,
    isDisabled,
    isPending,
    isElevated,
    "data-testid": dataTestId,
    children,
}) => {
    return (
        <AccessContainer>
            {({ orgAppAuth }) => {
                const createAppAuth = orgAppAuth.includes(AuthOperationTypes.Create);
                const updateAppAuth = orgAppAuth.includes(AuthOperationTypes.Update);
                const hasAdminAuth = createAppAuth && updateAppAuth;

                return (
                    <div>
                        <ActionDisabledTooltip
                            placement="left"
                            hasPermission={hasAdminAuth || hasApps}
                            message={
                                <UnauthorizedMessage
                                    text="You need the Organization Admin or Business Admin role to create an app."
                                    organizationId={organizationId}
                                />
                            }
                        >
                            <DisabledButtonToolipFix
                                isDisabled={(!hasAdminAuth && !hasApps) || isDisabled}
                                isPending={isPending}
                                isElevated={isElevated}
                                onClick={onClick}
                                type="primary"
                                data-testid={dataTestId}
                            >
                                {children}
                            </DisabledButtonToolipFix>
                        </ActionDisabledTooltip>
                    </div>
                );
            }}
        </AccessContainer>
    );
};
